module.exports = __webpack_public_path__ + "static/vegana200-a1e712661da9559b714c70e70d245c8f.png";